import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { searchReportComponent } from './searchReport.component';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../../directives/directives.module';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TableModule } from 'primeng-lts/table';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TreeModule } from 'primeng-lts/tree';


@NgModule({
  declarations: [searchReportComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    TreeModule,
    TableModule,
    DynamicDialogModule,
    DirectivesModule,
    DossierHeaderModule,
    WaitLoadingModule, ScrollPanelModule,
    PanelModule
  ],
  exports: [searchReportComponent, DirectivesModule]
})
export class searchReportModule { }
